package com.arena_web.ui.components.buttons

import androidx.compose.runtime.Composable
import com.arena_web.ui.theme.AppColors
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

@Composable
fun PrimaryButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    size: ButtonSize = ButtonSize.LG,
    fullWidth: Boolean = false
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Button(
        onClick = { onClick() },
        size = size,
        enabled = enabled,
        modifier = modifier
            .then(if (fullWidth) Modifier.fillMaxWidth() else Modifier)
            .backgroundColor(AppColors.Primary)
            .color(colors.onPrimary)
            .sPadding(12, 24)
            .sBorderRadius(8)
            .cursor(if (enabled) Cursor.Pointer else Cursor.NotAllowed)
            .opacity(if (enabled) 1.0 else 0.6)
    ) {
        SpanText(text)
    }
}

@Composable
fun SecondaryButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    size: ButtonSize = ButtonSize.LG,
    fullWidth: Boolean = false
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Button(
        onClick = { onClick() },
        size = size,
        enabled = enabled,
        modifier = modifier
            .then(if (fullWidth) Modifier.fillMaxWidth() else Modifier)
            .backgroundColor(colors.surface)
            .color(colors.textPrimary)
            .border(1.px, LineStyle.Solid, colors.border)
            .sPadding(12, 24)
            .sBorderRadius(8)
            .cursor(if (enabled) Cursor.Pointer else Cursor.NotAllowed)
            .opacity(if (enabled) 1.0 else 0.6)
    ) {
        SpanText(text)
    }
}

@Composable
fun TextButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    size: ButtonSize = ButtonSize.LG
) {
    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Button(
        onClick = { onClick() },
        size = size,
        enabled = enabled,
        modifier = modifier
            .backgroundColor(org.jetbrains.compose.web.css.Color("transparent"))
            .color(AppColors.Primary)
            .sPadding(8, 16)
            .cursor(if (enabled) Cursor.Pointer else Cursor.NotAllowed)
            .opacity(if (enabled) 1.0 else 0.6)
    ) {
        SpanText(text)
    }
}
